module.exports = __webpack_public_path__ + "img/stage3.be521389.png";